import { useTheme } from "@emotion/react";
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Link,
  styled,
  Tab,
  Tabs,
  TextField,
  useMediaQuery,
} from "@mui/material";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Toolbar from "@mui/material/Toolbar";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import * as React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { FiLogOut } from "react-icons/fi";
import { IoMenuSharp } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import useLogin from "../../hooks/useLogin";
import { setDarkMode, setLanguage } from "../../store/slice/collectionsSlice";
import { logout } from "../../store/slice/userSlice";
import i18n from "../../translation/languageModule";
import MobileNavigation from "./MobileNavigation";
import { login } from "../../store/thunks/user/login";
import axiosInstance from "../../api/axiosInstance";



const HeaderTab = styled(Tab)(({ theme, inView }) => ({
  color: theme.palette.text.primary,
  "&.Mui-selected": {
    textDecoration: "underline",
  },
  "&:hover": {
    textDecoration: "underline",
  },
}));

function Header() {
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const [anchorElLogin, setAnchorElLogin] = React.useState(null);
  const navigate = useNavigate();
  const isAuthenticated = useSelector((state) => state.user.isAuthenticated);
  const darkMode = useSelector((state) => state.collections.dark);
  const { handleLogin } = useLogin();
  const OpenLogin = Boolean(anchorElLogin);
  const [emailLogin, setEmailLogin] = useState(false);
  const handleLoginMenu = (event) => {
    setAnchorElLogin(event.currentTarget);
  };
  const [error, setError] = useState(false);
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const theme = useTheme();
  const { t } = useTranslation();
  

  const mobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const getInitialValue = () => {
    const savedTab = localStorage.getItem("selectedTab");
    if (savedTab !== null) {
      return Number(savedTab);
    } else {
      return 0;
    }
  };

  const [value, setValue] = useState(
    parseInt(localStorage.getItem("selectedTab"))
  );
  const handleChange = (event, newValue) => {
    setValue(newValue);
    localStorage.setItem("selectedTab", newValue);
  };

  const changeLanguage = (lang) => {
    dispatch(setLanguage(lang));
    i18n.changeLanguage(lang);
  };

  const handleToggle = (event) => {
    const isChecked = event.target.checked;
    dispatch(setDarkMode(isChecked));
  };

  if (mobile) {
    return <MobileNavigation />;
  }
  return (
    <AppBar
      position="sticky"
      sx={{ background: theme.palette.gradient.main, padding: ".5em 0" }}
    >
      <Container maxWidth="xl">
        <Toolbar disableGutters={true}>
          <Box
            noWrap
            display={"flex"}
            sx={{
              mr: 2,
              display: { xs: "none", md: "flex" },
              fontFamily: "monospace",
              fontWeight: 700,
              letterSpacing: ".3rem",
              color: "inherit",
              textDecoration: "none",
              marginLeft: 0,
              cursor: "pointer",
            }}
            onClick={() => {
              localStorage.setItem("selectedTab", 0);
              setValue("/orsee");
              navigate(process.env.REACT_APP_PREFIX);
            }}
          >
            <img
              src="/logo-labex.png"
              alt="logo-labex"
              style={{
                width: "150px",
                height: "auto",
                cursor: "pointer",
                padding: 2,
              }}
            />
          </Box>

          <Box
            sx={{
              flexGrow: 1,
              display: { xs: "none", md: "flex" },
              boxShadow: "none",
            }}
          >
            {isAuthenticated ? (
              <Tabs
                variant="scrollable"
                value={value}
                onChange={handleChange}
                TabIndicatorProps={{
                  sx: {
                    width: 3,
                    color: theme.palette.text.primary,
                    backgroundColor:
                      localStorage.getItem("selectedTab") && value === 0
                        ? "none"
                        : "#3b5b8c",
                    display: "none",
                  },
                }}
                sx={{ boxShadow: "none" }}
              >
                <HeaderTab
                  value={1}
                  label={t("menu_exp")}
                  onClick={() => {
                    localStorage.setItem("selectedTab", 1);
                    navigate(process.env.REACT_APP_PREFIX);
                  }}
                  sx={{
                    "&.Mui-selected": {
                      color: "#fff",
                      fontWeight: "bold",
                    },
                  }}
                />
                <HeaderTab
                  value={2}
                  label={t("menu_profile")}
                  onClick={() => {
                    localStorage.setItem("selectedTab", 2);
                    navigate(process.env.REACT_APP_PREFIX + "/profile");
                  }}
                  sx={{
                    "&.Mui-selected": {
                      color: "#fff",
                      fontWeight: "bold",
                    },
                  }}
                />

                <HeaderTab
                  value={3}
                  label={t("menu_rules")}
                  sx={{
                    "&.Mui-selected": {
                      color: "#fff",
                      fontWeight: "bold",
                    },
                  }}
                  onClick={() => {
                    localStorage.setItem("selectedTab", 3);
                    navigate(process.env.REACT_APP_PREFIX + "/rules&policies");
                  }}
                />
                <HeaderTab
                  value={4}
                  label={t("menu_help")}
                  sx={{
                    "&.Mui-selected": {
                      color: "#fff",
                      fontWeight: "bold",
                    },
                  }}
                  onClick={() => {
                    localStorage.setItem("selectedTab", 4);
                    navigate(process.env.REACT_APP_PREFIX + "/help");
                  }}
                />
              </Tabs>
            ) : (
              <Tabs
                variant="scrollable"
                value={value}
                onChange={handleChange}
                TabIndicatorProps={{
                  sx: {
                    width: 3,
                    backgroundColor:
                      localStorage.getItem("selectedTab") && value === 0
                        ? "none"
                        : "#fff",
                    display: "none",
                  },
                }}
                sx={{ boxShadow: "none" }}
              >
                <HeaderTab
                  value={3}
                  label={t("menu_rules")}
                  sx={{
                    "&.Mui-selected": {
                      color: "#fff",
                      fontWeight: "bold",
                    },
                  }}
                  onClick={() => {
                    localStorage.setItem("selectedTab", 3);
                    navigate(process.env.REACT_APP_PREFIX + "/rules&policies");
                  }}
                />
                <HeaderTab
                  value={1}
                  label={t("menu_help")}
                  sx={{
                    "&.Mui-selected": {
                      color: "#fff",
                      fontWeight: "bold",
                    },
                  }}
                  onClick={() => {
                    localStorage.setItem("selectedTab", 1);
                    navigate(process.env.REACT_APP_PREFIX + "/help");
                  }}
                />
              </Tabs>
            )}
          </Box>
          {!isAuthenticated && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                flexGrow: 1,
              }}
            >
              <Button
                variant="contained"
                onClick={handleLoginMenu}
                sx={{
                  marginLeft: "auto",
                  backgroundColor: "white",
                  color: "primary.100",
                  fontSize: "1em",
                  marginRight: 0,
                  padding: "8px 16px",
                  borderRadius: "20px",
                  textTransform: "none",
                  fontWeight: "bold",
                  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                  "&:hover": {
                    backgroundColor: "primary.main",
                    color: "text.primary",
                  },
                }}
              >
                Login
              </Button>
               <Menu
                  id="basic-menu"
                  anchorEl={anchorElLogin}
                  open={OpenLogin}
                  onClose={() => setAnchorElLogin(null)}
                  MenuListProps={{
                    'aria-labelledby': 'basic-button',
                  }}
                >
                  <MenuItem onClick={handleLogin}>Login using switchEDU ID</MenuItem>
                  <MenuItem onClick={()=> setEmailLogin(true)}>Login using email</MenuItem>
                </Menu>
            </Box>
          )}

          <Box sx={{ flexGrow: 0 }} marginRight={10} marginLeft={4}>
            <Tooltip title="Open Menus">
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                <IoMenuSharp />
              </IconButton>
            </Tooltip>
            <Menu
              sx={{
                mt: "45px",
                "& ul": {
                  backgroundColor: "secondary.200",
                  padding: "2em",
                },
                width: "20%",
              }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              <MenuItem
                key="en"
                onClick={() => {
                  setAnchorElUser(null);
                  changeLanguage("en");
                }}
              >
                <Typography
                  sx={{
                    fontSize: "1.1em",
                  }}
                  textAlign="center"
                >
                  English
                </Typography>
              </MenuItem>
              <MenuItem
                key="fr"
                onClick={() => {
                  setAnchorElUser(null);
                  changeLanguage("fr");
                }}
              >
                <Typography
                  sx={{
                    fontSize: "1.1em",
                  }}
                  textAlign="center"
                >
                  Français
                </Typography>
              </MenuItem>
             {/*} <MenuItem
                key="ger"
                onClick={() => {
                  setAnchorElUser(null);
                  changeLanguage("de");
                }}
              >
                <Typography
                  sx={{
                    fontSize: "1.1em",
                  }}
                  textAlign="center"
                >
                  Deutsch
                </Typography>
              </MenuItem>*/}

              {/* <MenuItem key="dark-mode">
                  <Typography textAlign="center">Dark Mode</Typography>
                  <Switch
                    checked={darkMode}
                    onChange={handleToggle}
                    inputProps={{ "aria-label": "controlled" }}
                    sx={{ marginLeft: 1 }}
                  />
                </MenuItem>
                 */}

              {isAuthenticated && (
                <>
                  <Divider sx={{ my: 1 }} />
                  <MenuItem
                    key="logout"
                    onClick={() => {
                      dispatch(logout());
                      setAnchorElUser(null);
                    }}
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      color: "text.primary",
                    }}
                  >
                    <Typography textAlign="center">Logout</Typography>
                    <FiLogOut />
                  </MenuItem>
                 
                </>
              )}
            </Menu>
          </Box>
        </Toolbar>
      </Container>
      <Dialog
        open={emailLogin}
        onClose={() => setEmailLogin(false)}
        PaperProps={{
          component: 'form',
          onSubmit: (event) => {
            event.preventDefault();
            setError(false);
            const formData = new FormData(event.currentTarget);
            axiosInstance.post('/auth/login', formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            }})
            .then (response => {
              localStorage.setItem('jwtToken', response.data.token);
              navigate('/orsee');
            })
            .catch(error => {
              setError(true);
            });
          },
        }}
      >
        <DialogTitle>Login using email</DialogTitle>
        <DialogContent>
          {error && <Alert severity="error" sx={{ mb: 2 }}>
            Incorrect credentials. Please try again.
          </Alert>}
          <TextField
            autoFocus
            required
            margin="dense"
            id="email"
            name="email"
            label="Email Address"
            type="email"
            fullWidth
            variant="standard"
          />
          <TextField
            autoFocus
            required
            margin="dense"
            id="password"
            name="password"
            label="Password"
            type="password"
            fullWidth
            variant="standard"
          />
        </DialogContent>
        <DialogActions>
          <Button type="submit">Login</Button>
        </DialogActions>
      </Dialog>
    </AppBar>
  );
}

export default Header;
